import { ACTS, DockIcon, type MeterId } from "./icons";

export interface DockProps {
  controls: "touch" | "retro";
  disabled: boolean;
  petName?: string;
  selectedIndex?: number;
  onCare(meter: MeterId): void;
}

export function Dock({
  controls,
  disabled,
  petName,
  selectedIndex = 0,
  onCare,
}: DockProps) {
  if (controls === "retro") {
    return (
      <div
        className={`ibar${disabled ? " off" : ""}`}
        id="dock"
        data-testid="dock"
        aria-hidden="true"
      >
        {ACTS.map((a, i) => (
          <span
            key={a.id}
            id={`dk${i}`}
            data-testid={`care-${a.m}`}
            className={i === selectedIndex ? "sel" : undefined}
          >
            <DockIcon id={a.id} />
            {a.name}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`dock${disabled ? " off" : ""}`}
      id="dock"
      data-testid="dock"
    >
      {ACTS.map((a, i) => (
        <button
          key={a.id}
          type="button"
          id={`dk${i}`}
          data-testid={`care-${a.m}`}
          disabled={disabled}
          aria-label={petName ? `${a.name} ${petName}` : a.name}
          onClick={() => onCare(a.m)}
        >
          <DockIcon id={a.id} />
          <span>{a.name}</span>
        </button>
      ))}
    </div>
  );
}
